export default __webpack_public_path__ + "static/media/img-4839.47106b42.jpeg";